document.addEventListener('DOMContentLoaded', function() {
  const promotions = document.querySelectorAll('.scrolling-promotion');
  promotions.forEach(promotion => {
    const speed = promotion.getAttribute('data-speed');
    promotion.style.setProperty('--duration', `${speed}s`);
  });
});

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.popup-link-custom').forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      const popupBlock = this.closest('.popup-block-custom');
      popupBlock.classList.toggle('active');
    });
  });
});
